import CLIENT from '../actionTypes';

import { AppAction } from '../../../types/app';
import { ClientPersonalInfoState } from '../types';

const initialState: ClientPersonalInfoState = {
  loadReadyStatus: CLIENT.PERSONAL_INFO.LOAD.INVALID,
  loadErr: null,
  info: null,

  saveReadyStatus: CLIENT.PERSONAL_INFO.SAVE.INVALID,
  saveErr: null,
};

export default (
  state: ClientPersonalInfoState = initialState,
  action: AppAction = {}
): ClientPersonalInfoState => {
  switch (action.type) {
    case CLIENT.PERSONAL_INFO.LOAD.REQUESTING:
      return {
        ...state,
        loadErr: null,
        loadReadyStatus: action.type,
      };
    case CLIENT.PERSONAL_INFO.LOAD.FAILURE:
      return {
        ...state,
        loadReadyStatus: action.type,
        loadErr: action.err,
      };
    case CLIENT.PERSONAL_INFO.LOAD.SUCCESS:
      return {
        ...state,
        loadErr: null,
        loadReadyStatus: action.type,
        info: action.data,
      };
    case CLIENT.PERSONAL_INFO.SAVE.REQUESTING:
      return {
        ...state,
        saveReadyStatus: action.type,
        saveErr: null,
      };
    case CLIENT.PERSONAL_INFO.SAVE.FAILURE:
      return {
        ...state,
        saveReadyStatus: action.type,
        saveErr: action.err,
      };
    case CLIENT.PERSONAL_INFO.SAVE.SUCCESS:
      return {
        ...state,
        saveReadyStatus: action.type,
        saveErr: null,
      };
    default:
      return state;
  }
};
